//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiButton from "../../components/button/Index.vue";
import HiCell from "../../components/cell/Index.vue";
import { getPostBy, approvePostBy } from "../../services/post";
import moment from "moment-timezone";
import { VALIDATE_INFO } from "../../store/mutation-types";
import tagPeopleGroup from "../../components/tag/Group";
import { showErrorMsg } from "../../utils/error";
import HiVideo from "../../components/media/Video";
import demo from "./product";
export default {
  name: "ValidateHomePage",
  components: { HiButton, HiCell, tagPeopleGroup, HiVideo },
  data() {
    return {
      model: {
        medias: [],
      },
      swiperOption: {},
    };
  },
  computed: {
    igTV() {
      return this.model.media_type === 22;
    },
    story() {
      return this.model.media_type === 3;
    },
    /**
     * 所有的user tag
     */
    userTags() {
      let tags = [];
      this.model.medias.forEach((img) => {
        if (img.usertags) {
          img.usertags.forEach((tag) => {
            // 查看是否存在重复项
            const index = tags.findIndex((t) => t.user_id === tag.user_id);
            if (index === -1) {
              tags.push(tag);
            }
          });
        }
      });
      return tags;
    },
    /**
     * 格式化tag people
     */
    tagPeopleText() {
      if (this.userTags.length > 1) {
        return `${this.userTags.length} People`;
      } else if (this.userTags.length === 1) {
        return this.userTags[0].username;
      } else {
        return "";
      }
    },
    /**
     * 计算tag products 文案
     */
    tagProductsText() {
      if (this.tagProducts && this.tagProducts.length > 0) {
        return `${this.tagProducts.length} Products`;
      } else {
        return "";
      }
    },
    /**
     * 计算product tag
     */
    tagProducts() {
      let tags = [];
      this.model.medias.forEach((img) => {
        if (img) {
          if (img.product_tags) {
            img.product_tags.forEach((tag) => {
              // 查看是否存在重复项
              const index = tags.findIndex((t) => t.id === tag.id);
              if (index === -1) {
                tags.push(tag);
              }
            });
          }
        }
      });
      return tags;
    },
  },
  methods: {
    async approveClick(status) {
      this.$loading.show();
      try {
        await approvePostBy({ status, token: this.$route.params.token });
        // 审批后跳转下载页面 2：接受，3：拒绝
        const type = status === 2 ? "approve" : "decline";
        this.$router.push({ name: "ValidateDownloadPage", query: { type } });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    toTagPeoplePage() {
      this.$router.push({
        name: "ValidateTagPeoplePage",
        query: { type: "people" },
      });
    },
    toTagProductPage() {
      this.$router.push({
        name: "ValidateTagPeoplePage",
        query: { type: "product" },
      });
    },
    toCommentPage() {
      this.$router.push({ name: "ValidateCommentPage" });
    },
  },
  async created() {
    this.$loading.show();
    try {
      // 正方形多tag people MTQyODU-5ep-3ab13e59660ae283faac
      // 非方形多tag people MTQyODY-5eq-b1870da28ee15a313dc0
      let token = this.$route.params.token;
      if (token === "product") {
        token = "MTQyODU-5ep-3ab13e59660ae283faac";
      }
      const data = await getPostBy({ token: token });
      // 判断当前状态是否有问题
      if (data.reviewing_status === 2) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: { type: "approve" },
        });
        return;
      }
      if (data.reviewing_status === 3) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: { type: "decline" },
        });
        return;
      }
      if (this.$route.params.token === "product") {
        data.medias.forEach((m) => {
          m.usertags = [];
          m.product_tags = demo[0].product_tags;
        });
      }
      data.post_time = moment
        .tz(data.post_time, data.tz_name)
        .format("MMM DD, YYYY HH:mm");
      if (data.delete_time) {
        data.delete_time = moment
          .tz(data.delete_time, data.tz_name)
          .format("MMM DD, YYYY HH:mm");
      }
      data.locationName = data.location ? data.location.name : ""; // 地理位置
      data.medias = data.medias || [];
      this.$set(this, "model", data);
      this.$store.commit(VALIDATE_INFO, data);
    } catch (e) {
      if (e.errorCode === 4404) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: {
            msg: "This link is expired. Please ask the sender to send a new link.",
          },
        });
        return;
      }
      console.error(e);
    } finally {
      this.$loading.hide();
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/validate/Home.vue